<template>
  <Dialog
    :visible="showDialog"
    :style="{ width: '600px' }"
    :header="add ? 'Agregar Módulo' : 'Editar Módulo'"
    :modal="true"
    class="p-fluid"
    @update:visible="hideDialog"
    @hide="hideDialog"
  >
    <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
      <form role="form" @submit.prevent="handleSubmit(submitForm)">
        <base-input
          v-model="innerValue.module_name"
          rules="required|min:3"
          label="Nombre"
          name="Nombre"
          type="text"
        />
        <base-input
          v-model="innerValue.module_code"
          rules="required|min:7"
          label="Código "
          name="Código"
          type="text"
        />
        <base-input
          v-model="innerValue.module_description"
          label="Descripción"
          name="Descripción"
          rules="required|min:3"
          type="text"
        />
        <base-input
          v-model="innerValue.description_evaluation_approval"
          label="Detalle forma de evaluación y aprobación del módulo"
          name="Detalle forma de evaluación y aprobación del módulo"
          type="text"
        />
        <base-input
          v-model="innerValue.module_formation"
          label="Formación"
          name="Formación"
          type="text"
        />
        <base-input
          v-model="innerValue.module_competence"
          label="Competencia"
          name="Competencia"
          type="text"
        />
        <base-input
          v-model="innerValue.module_modality"
          label="Modalidad"
          name="Modalidad"
          type="text"
        />
        <base-input
          v-model="innerValue.module_ucl"
          label="UCL"
          name="UCL"
          type="text"
        />
        <div class="p-grid">
          <div class="p-col-12 p-md-6">
            <base-input
              v-model="innerValue.course_start_date"
              label="Fecha inicio"
              name="Fecha inicio"
              type="date"
            />
          </div>
          <div class="p-col-12 p-md-6">
            <base-input
              v-model="innerValue.course_end_date"
              label="Fecha fin curso"
              name="Fecha fin curso"
              type="date"
            />
          </div>
        </div>
        <div
          class="p-fileupload p-fileupload-basic p-component p-field p-col-12 p-p-0"
        >
          <label>Manual del curso <a v-if="innerValue.manual" :href="innerValue.manual" class="pl-2" style="background-color: #e3f2fd; color: rgba(0,0,0,0.87)" target="_blank">{{ innerValue.manual }}</a></label>
          <input
            v-if="innerValue.manual == null"
            ref="manual"
            type="file"
            accept="application/pdf"
            class="custom-file-input course-manual-file-input pt-1"
            v-on:change="handleManualUpload()"
          />
          <input
            v-if="innerValue.manual != null"
            ref="manual"
            type="file"
            accept="application/pdf"
            class="custom-file-input up-course-manual-file-input pt-1"
            v-on:change="handleManualUpload()"
          />
        </div>
        <base-input-select
          v-model="innerValue.teacher"
          :options="teachers"
          :customValue="['nombre', 'apellido']"
          :customOption="['nombre', 'apellido']"
          label="Profesor"
          name="Profesor"
          optionLabel="id"
          placeholder="Seleccione un profesor"
          rules="required"
        />
        <div class="p-d-flex pt-2">
          <Button
            label="Cancelar"
            icon="pi pi-times"
            class="p-button-text mx-2"
            type="button"
            @click="hideDialog"
          />
          <Button
            class="mx-2"
            label="Guardar"
            icon="pi pi-check"
            type="submit"
          />
        </div>
      </form>
    </ValidationObserver>
  </Dialog>
</template>

<script>
import Module from "@/models/module.model";
import moduleService from "@/services/axios/module.service";
export default {
  props: {
    showDialog: {
      type: Boolean,
      required: true
    },
    add: {
      type: Boolean,
      default: true
    },
    idCurso: {
      required: true
    },
    value: {
      type: Object,
      required: true
    },
    teachers: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      innerValue: new Module(),
      manualFile: null
    };
  },
  watch: {
    value(newVal) {
      this.innerValue = { ...newVal, course_id: this.idCurso };
    }
  },
  methods: {
    hideDialog() {
      this.$emit("close");
    },
    submitForm() {
      let { ...rest } = this.innerValue;
      const mod = { ...rest };
      var formData = new FormData();

      formData.append("course_end_date", mod.course_end_date);
      formData.append("course_id", mod.course_id);
      formData.append("course_start_date", mod.course_start_date);
      formData.append("created_at", mod.created_at);
      formData.append("description_evaluation_approval", (mod.description_evaluation_approval ? mod.description_evaluation_approval : ''));
      formData.append("manual", mod.manual);
      formData.append("module_code", mod.module_code);
      formData.append("module_competence", (mod.module_competence ? mod.module_competence : ''));
      formData.append("module_description", mod.module_description);
      formData.append("module_duration", 0);
      formData.append("module_formation", (mod.module_formation ? mod.module_formation : ''));
      formData.append("module_id", mod.module_id);
      formData.append("module_modality", (mod.module_modality ? mod.module_modality : ''));
      formData.append("module_name", mod.module_name);
      formData.append("module_status", mod.module_status);
      formData.append("module_status_minutes", mod.module_status_minutes);
      formData.append("module_ucl", (mod.module_ucl ? mod.module_ucl : ''));
      formData.append("module_year", mod.module_year);
      formData.append("autor_id", mod.teacher.id);
      formData.append("manual_file", this.manualFile);
      formData.append("updated_at", mod.updated_at);

      if (this.add) this.saveModule(formData);
      else this.updateModule(formData);
    },
    saveModule(mod) {
      if (typeof mod.course_start_date !== "string") {
        mod.course_start_date = null;
      }
      if (typeof mod.course_end_date !== "string") {
        mod.course_end_date = null;
      }
      moduleService
        .save(mod)
        .then(({ data }) => {
          this.$emit("setModules", data);
          this.$swal({
            text: "Módulo creado con éxito",
            icon: "success"
          });
        })
        .catch(error => {
          this.$swal({
            icon: "error",
            title: `Error`,
            text: error.response.data.error
          });
        });
    },
    updateModule(mod) {
      const headers = {
        "Content-Type": "multipart/form-data"
      };
      this.$http
        .post(
          `${process.env.address.api}modules/${mod.get('module_id')}/update`,
          mod,
          { headers }
        )
        .then(({ data }) => {
          this.$emit("setModules", data);
          this.$swal({
            text: "Módulo actualizado con éxito",
            icon: "success"
          });
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: "error",
              title: `Error`,
              text: error.response.data.error
            });
          }
        });
    },
    handleManualUpload() {
      this.manualFile = this.$refs.manual.files[0];
    },
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Module/ModuleDialog.vue